import StepId from "@/model/progress/StepId"

export default [
    {
        name: "prove",
        path: "/providers/:providerKey/modes/:mode/primary/prove",
        meta: { step: StepId.PATIENT_INFO },
        component: () => import("@/views/prove/ProveChallengeView.vue"),
    },
    {
        name: "instant-link",
        path: "/providers/:providerKey/modes/:mode/primary/prove/instant-link",
        component: () => import("@/views/prove/ProveInstantLinkView.vue"),
    },
    {
        name: "enter-manually",
        path: "/providers/:providerKey/modes/:mode/primary/prove/enter-manually",
        redirect: "/providers/:providerKey/modes/:mode/primary/start",
    },
    {
        name: "verifying",
        path: "/providers/:providerKey/modes/:mode/primary/prove/verifying",
        component: () => import("@/views/prove/ProveVerifyingView.vue"),
    },
    {
        name: "verified",
        path: "/providers/:providerKey/modes/:mode/primary/prove/verified",
        component: () => import("@/views/prove/ProveVerifiedView.vue"),
    },
    {
        name: "edit-information",
        path: "/providers/:providerKey/modes/:mode/primary/prove/edit-information",
        component: () => import("@/views/prove/ProveEditInformationView.vue"),
    },
]
